import { render, staticRenderFns } from "./AplicacaoRecursoForm.vue?vue&type=template&id=bec3b2f2"
import script from "./AplicacaoRecursoForm.vue?vue&type=script&lang=js"
export * from "./AplicacaoRecursoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports